// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1bI-B","title":"FrontImage_title__2y-Ej"};